import { Dropdown } from "primereact/dropdown";
import RegistrationDelimitationSelector from "../componets/RegistrationDelimitationSelector";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { changeLang } from "../componets/Language/ChangeLang";
import { useState } from "react";
import { Button } from "primereact/button";
import { mapDelimitation } from "../componets/utils/helper";
import { dermacationsTypes, dermacationsTypesID } from "../constants";


export default function ({
    loading, onRegistrationCentreSelected, permission, permissionLookUp,
    setShowRegistrionCentreSelector, showRegistrionCentreSelector, selectedUser,
    delimitations, confirmDeleteDelimitation,
    filters
}) {

    const [selectedDemarcation, setSelectedDemarcation] = useState(dermacationsTypes[0].id);
    var userDelimtation = delimitations.filter(e => e.demarcationTypeID === selectedDemarcation)
    var isNational= selectedDemarcation === dermacationsTypesID.National_Assembly_Structure

   

    return (<>

        <div className="mb-3" style={{ display: "flex", alignItems: "center" }}>
            <Dropdown
                value={selectedDemarcation}
                placeholder="Select Demarcation type"
                className="w-full mr-2"
                // showClear
                options={dermacationsTypes}
                optionLabel="name"
                optionValue="id"
                onChange={(e) => {
                    const obj = e.value;
                    setSelectedDemarcation(obj);
                    // const id = obj?.id ?? null;
                    // if (id != null) {
                    //     fetchDistricts(id);
                    // } else {
                    //     setNodes([]);
                    // }
                }}
            />
            {(permission?.actions?.includes(permissionLookUp.Update) ||
                permission?.actions?.includes(permissionLookUp.Create)) && (
                    <Button
                        className="p-button-success"
                        icon="pi pi-plus"
                        label="Assign"
                        onClick={(e) => {
                            setShowRegistrionCentreSelector(true);
                        }}
                    />
                )}
        </div>


        <div className="grid" style={{ flex: 1 }}>
            <div className="col-12 lg:col-12">
                <DataTable
                    size="small"
                    scrollable={true}
                    value={userDelimtation}
                    dataKey="id"
                    className="datatable-responsive"
                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} Members"
                    emptyMessage="No delimitation(s) found."
                    responsiveLayout="scroll"
                    resizableColumns
                    columnResizeMode="expand"
                    filters={filters}
                    filterDisplay="Name"
                    globalFilterFields={["Name"]}
                    loading={loading}
                >
                    <Column field="districtName" header={changeLang.get("national_delimitation.district")}></Column>
                    <Column field="constituencyName" header={isNational?changeLang.get("national_delimitation.constituency"): changeLang.get("local_delimitation.council")}></Column>
                    <Column field="pollingDivisionName" header={isNational?changeLang.get("national_delimitation.electoralDivision"):changeLang.get("local_delimitation.electoralDivision")}></Column>
                    <Column field="registrationCentreName" header={isNational?changeLang.get("national_delimitation.votingCentre"):changeLang.get("local_delimitation.pollingStation")}></Column>

                    {permission?.actions?.includes(permissionLookUp.Delete) && (
                        <Column
                            field="actions"
                            header="Actions"
                            body={(e) => (
                                <>
                                    <Button
                                        onClick={() => {
                                            console.log(e)
                                            e.demarcationTypeID=selectedDemarcation
                                            confirmDeleteDelimitation(e, false);
                                        }}
                                        style={{ textAlign: "center", width: "30px", height: "30px" }}
                                        icon={"pi pi-trash"}
                                        className="p-button-danger p-button-rounded mr-2"
                                        tooltip="Click to delete"
                                    />
                                </>
                            )}
                        ></Column>
                    )}
                </DataTable>
                <RegistrationDelimitationSelector
                    show={showRegistrionCentreSelector}
                    selectedUser={selectedUser}
                    userDelimitations={userDelimtation}
                    isNational={isNational}
                    demarcationTypeID={selectedDemarcation}
                    onSubmit={(data) => onRegistrationCentreSelected(data)}
                    onHide={() => setShowRegistrionCentreSelector(false)}
                />
            </div>
        </div>

    </>)
}